import { Parameters } from '../../../interfaces/Parameters';
import { ParametersDto } from '../../../interfaces/dtos/ParametersDto';

export default function transformParameters(dto: ParametersDto): Parameters {
  if (!dto) return null;

  const parameters: Parameters = {
    companyCodesForContractSearch: dto.companyCodesForContractSearch,
    maxAttachmentNumber: dto.maxAttachmentNumber,
    maxAttachmentSize: dto.maxAttachmentSize,
    maxMessagesCount: dto.maxMessagesCount,
    maxMessagesEllapseMinutes: dto.maxMessagesEllapseMinutes,
    supportedAttachmentExtensions: dto.supportedAttachmentExtensions,
    supportedAttachmentTypes: dto.supportedAttachmentTypes,
  };

  return parameters;
}
